import { configureStore } from "@reduxjs/toolkit";
import appReducer from "./slices/appSlice";
import contractsReducer from "./slices/contractsSlice";
import notificationReducer from "./slices/notificationSlice";

export const store = configureStore({
  reducer: {
    app: appReducer,
    contracts: contractsReducer,
    notifications: notificationReducer,
  },
  devTools: process.env.NODE_ENV === "development",
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;